import { createSlice } from '@reduxjs/toolkit'

const advertisingCampaignsSlice = createSlice({
    name: 'advertisingCampaigns',
    initialState: {
        isOpenAddAdvertisementFile: false,
        waitingImport: false,
    },
    reducers: {
        openAddFileModal(state, action) {
            state.isOpenAddAdvertisementFile = action.payload
        },
        setWaitingImport(state, action) {
            state.waitingImport = action.payload
        },
    },
})

const { reducer: advertisingCampaignsReducer, actions: advertisingCampaignsActions } = advertisingCampaignsSlice
export { advertisingCampaignsReducer, advertisingCampaignsActions }
